var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart-captcha",style:(_vm.captchaStyles),attrs:{"id":_vm.widgetId}})
}
var staticRenderFns = []

export { render, staticRenderFns }